import params from "../../../config/params";
import axios from "axios";

require("dotenv").config();

let BASE_URL = params.PROD.MICRO_SERVICES.CAUSE.CAUSE_LIST;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.MICRO_SERVICES.CAUSE.CAUSE_LIST;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.MICRO_SERVICES.CAUSE.CAUSE_LIST;
}

const getCauseCodeBySubfamily = () => {
  return axios.get(
    `${BASE_URL}/cause-list-by-subfamily`
  );
}

export default {
  // ids: [66, 104, 111, 165, 173, 176, 177, 178, 506, 509],
  getCauseCodeBySubfamily
};
